<template>
  <div id="assign-to-class">
    <div class="base-create">
      <div  v-for="(item,index) in assigned_group" :key="item.id">
        <el-row class="mb-px-16 mt-px-16">
          <el-col :span="8">
            <div class="class-row">
              <p>
                <span class="label">{{item.group_name}}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="date-row">
              <p>
                <span class="label">{{$t("study_sets.assigned_on_date",{
                  date: formatDate(item.created_at)
                  })}}</span>
              </p>
            </div>
          </el-col>
        
        </el-row>
        <hr v-if="index < assigned_group.length - 1" />
        
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { DATE_FORMAT } from "@/constants/generic"

export default {
  components: {
   
  },
  props: {
    readAloudDetails: {},
    organizationType: {},
    organizationId: {},
     dateFormat: {
      type: String,
      default: DATE_FORMAT
    }
  },
  data() {
    return {
    }
  },
  computed: {
    assigned_group() {
      return this.readAloudDetails &&this.readAloudDetails.assigned_group? this.readAloudDetails.assigned_group: [];
    },
  },
  methods: {
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : '--'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
h3 {
  text-transform: none;
}
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}

#assign-to-class {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 8px 64px;
  margin-bottom: 24px;
  min-height: 80px;
}

.class-row {
  padding:10px 0px;
  p {
    font-weight: 600;
    font-size: 16px;
    color: #121131;
    margin: 0;
    text-align: initial;
  }
}
.date-row {
  padding:10px 0px;
  p {
    font-weight: 400;
    font-size: 16px;
    color: #121131;
    margin: 0;
    text-align: right;
  }
}
.button-row {
  p {
    font-weight: 600;
    font-size: 16px;
    color: #121131;
    margin: 0;
    text-align: initial;
  }
}
</style>
